import React, { useState } from 'react';
import classnames from 'classnames';
import Wysiwyg from '../../../../common/components/wysiwyg';
import renderRawHtml from '../../../../common/render_raw_html';
import InfoToolTip from '../infoToolTip';

const CustomQualifiedMessage = ({
  qualifyMessageTitle, qualifyMessageHint, errorText, data, placeholder
}) => {
  const [ customQualified, setCustomQualified ] = useState(data.custom_qualified);
  const [ text, setText ] = useState(data.qualified_text);

  const handleChangeCustomQualified = (event) => {
    setCustomQualified(!customQualified);
  };

  return (
    <>
      <input type="hidden" name="project[qualified_text]" value={ text } />
      <div className="form_section-title -grid">
        <div className="form_section-title-item -grid">
          <div className="toggle">
            <input name="project[custom_qualified]" type="hidden" value="0" autoComplete="off" />
            <input
              id="project_custom_qualified"
              type="checkbox"
              name="project[custom_qualified]"
              className="hide"
              checked={ customQualified }
              value="1"
              onChange={ handleChangeCustomQualified }
            />
            <label className="form-switch" htmlFor="project_custom_qualified">
              Custom qualified
            </label>
          </div>
          <h3 { ...renderRawHtml(qualifyMessageTitle) } />
        </div>
        <div className="form_section-title-item">
          <InfoToolTip
            remote
            text={ qualifyMessageHint }
            position="bottom-right"
          />
        </div>
      </div>
      {
        customQualified &&
        <div className={ classnames("form-group", { 'has-error': !!errorText }) } >
          <Wysiwyg
            toolbarClassName="wysiwyg-menu"
            editorClassName="wysiwyg-textarea"
            customPicker
            placeholder={ placeholder }
            value={ text }
            onChange={ setText }
            enableIndent
          />
          <div className="form-error" { ...renderRawHtml(errorText) } />
        </div>
      }
    </>
  );
};

export default CustomQualifiedMessage;
